var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutpatiented(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655274675277,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5418,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515.3 180.8c43.9 0 79.6 34.7 79.6 77.3s-35.7 77.3-79.6 77.3-79.6-34.7-79.6-77.3 35.7-77.3 79.6-77.3m0-50c-71.6 0-129.6 57-129.6 127.3s58 127.3 129.6 127.3 129.6-57 129.6-127.3-58-127.3-129.6-127.3z",
    "p-id": 5419,
    fill: "#3C91F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M737.9 611.1h-50c0-98.8-72.8-179.2-162.2-179.2h-24.8c-89.5 0-162.2 80.4-162.2 179.2h-50v-14.3h0.4C296 477 388.3 381.9 500.9 381.9h24.8c112.6 0 205 95.2 211.8 214.9h0.4v14.3z",
    "p-id": 5420,
    fill: "#3C91F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M833.7 578H190.9v50h642.8v-50z",
    "p-id": 5421,
    fill: "#3C91F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.2 611.3v264c0 11 9 20 20 20h516.3c11 0 20-9 20-20v-264H233.2z m368.6 135.1c0 11-9 20-20 20h-40.5v39.5c0 11-9 20-20 20h-10c-11 0-20-9-20-20v-39.5h-42.5c-11 0-20-9-20-20v-10c0-11 9-20 20-20h42.5v-43.5c0-11 9-20 20-20h10c11 0 20 9 20 20v43.5h40.5c11 0 20 9 20 20v10z",
    "p-id": 5422,
    fill: "#3C91F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutpatiented);
export default __webpack_public_path__ + "static/media/outpatiented.265de7d7.svg";
export { ForwardRef as ReactComponent };